import MODULES from "@config/Modules/Shared/modules";
import { MouseEventHandler, ReactElement } from "react";
import SidebarLink from "../../SidebarLink";

interface IModules {
  onClick: MouseEventHandler<HTMLAnchorElement>;
  sidebarCollapse: boolean;
  isOpen: string;
  setIsOpen: Function;
}

const Modules = ({ onClick }: IModules): ReactElement => {
  const { SECTIONS } = MODULES;

  return (
    <ul className="sidebar__block">
      {SECTIONS.map(({ name, route }, index) => (
        <SidebarLink key={index} title={name} route={route} onClick={onClick} />
      ))}
    </ul>
  );
};

export default Modules;
